import { render, staticRenderFns } from "./TextLowercaseIcon.vue?vue&type=template&id=06d8e558&"
import script from "./TextLowercaseIcon.vue?vue&type=script&lang=js&"
export * from "./TextLowercaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports